import { EngagementToolEnum as TsClientEngagementToolEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-tool.enum'

export const EngagementToolEnum = {
  ...TsClientEngagementToolEnum,
}

export type EngagementToolEnum = TsClientEngagementToolEnum
